
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import React from "react";
import ProtectedRoute from "./ProtectedRoute";
import { LiveAuctionDetailed } from "../pages/LiveAuctionDetailed/LiveAuctionDetailed";
import { liveAuctionLoader } from "./loader/liveAuctionLoader";
import List from "../pages/property/List"
import MyBids from '../pages/MyBids';
import AuctionPage from '../components/auctionPage/AuctionPage';
import Signup from '../pages/Signup';
import Signin from '../pages/Signin';
import KYB from '../pages/KYB';
import ManageFunds from '../pages/manageFunds/ManageFunds';
import BiddingAgreement from "../pages/KYB/BiddingAgreementVerification";
import Form from "../components/KYB/IdentityVerfication"
import BiddingAgreementForm from "../components/KYB/BiddingAgreement"
import IdentityVerification from "../pages/KYB/IdentityVerification"
import BankAccountVerification from "../pages/KYB/BankAccountVerification"
import BusinessInfo from "../components/KYB/IdentityVerfication/businessInfo";
import Inprogress from "../components/KYB/IdentityVerfication/IndividualInprogress";
import InprogressValidation from "../components/KYB/IdentityVerfication/IndividualInVerify"
import DocumentVerification from '../components/KYB/IdentityVerfication/DocumentVerification';
import ReUploadDocumentVerification from '../components/KYB/IdentityVerfication/DocumentVerificationFailed';
import BusinessInprogress from "../components/KYB/IdentityVerfication/BusinessInprogress"
import AddBankAccount from '../components/KYB/IdentityVerfication/BankAccountLink';
import AddFunds from '../components/KYB/IdentityVerfication/AddFunds';
import AddFundsBank from '../components/KYB/IdentityVerfication/AddFundsBank';
import IndentityVerificationWrapper from '../pages/MyProfile/IndentityVerificationWrapper';
import Calender from '../pages/Calender/AuctionCalender';
import Favorites from '../pages/FavoriteProperties/Favorties';
import DisclosureDocuments from '../pages/DisclosureDocuments/DisclosureDoc';
import CompletedAuction from '../pages/CompletedAuction'
import ManageAddFunds from "../pages/manageFunds/AddFunds";
import ManageAddFundsWire from "../pages/manageFunds/AddFundsWire";
import WithdrawalFunds from "../pages/manageFunds/WithdrawalFunds";
import TransactionHistory from "../pages/manageFunds/TransactionHistory";
import { Profile } from "../pages/MyProfile/Profile";
import { PurchaseProfile } from "../pages/MyProfile/PurchaseProfile";
import { KybIndentityVerification } from "../pages/MyProfile/KybIndentityVerification";
import MyProfile from "../pages/MyProfile";
import VerificationFailed from "../components/KYB/IdentityVerfication/VerificationFailed";
import Emailvalidation from "../components/KYB/IdentityVerfication/Emailvalidation";
import NotInvitedUser from "../pages/KYB/NotInvitedUser";
import SilaVerificationFailed from "../components/KYB/IdentityVerfication/SilaVerificationFailed";
import KybUplaodDocument from "../components/KYB/IdentityVerfication/KybUplaodDocument";
import  DocumentRequiredForPurchase  from "../pages/MyProfile/DocumentRequiredForPurchase";
import KybdocumentVerification from "../components/KYB/IdentityVerfication/KybdocumentVerification";
import KybDocumentforPurchaseProfile from './../pages/MyProfile/KybDocumentforPurchaseProfile';
import DocRender from "../utils/DocRender";
import DocumentVerificationPriority from "../components/KYB/IdentityVerfication/DocumentVerificationPriority";
import Document from "../components/KYB/IdentityVerfication/forms/Document";
import PurchaseProfileBusinessInfo from "../components/KYB/IdentityVerfication/businessInfo/PurchaseProfileBusinessInfo";
export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: (
          <MyBids />
        ),
      },
      {
        path: "home",
        element: (

          <MyBids />
        ),
      },
      {
        path: "auctionPage/:propertyId",
        element: (
          <AuctionPage />
        ),
      },
      {
        path: "auctioncalendar",
        element: (
          <Calender />
        ),
      },
        {
        path: "add-document",
        element: (
          <Document />
        ),
      },
      {
        path: "search",
        element: (

          <List />
        ),
      },
      {
        path: "liveauction",
        // loader:liveAuctionLoader,// Attach loader with SignalR connection
        element: <LiveAuctionDetailed />,
      },
      {
        path: "liveauction/:id",
        element: <LiveAuctionDetailed />,
      },
      {
        path: "managefunds",
        children: [
          {
            index: true,
            element: (
              <ManageFunds />
            ),
          },
          {
            path: "add-fund",
            element: (<ManageAddFunds />),
          },
          {
            path: "add-fund-wire-transfer",
            element: (
              <ManageAddFundsWire />
            ),
          },
          {
            path: "withdrawal-fund",
            element: (
              <WithdrawalFunds />
            ),
          },
          {
            path: "transaction-history",
            element: (
              <TransactionHistory />
            ),
          },
        ],
      },
      {
        path: "favorites",
        element: (
          <Favorites />
        ),
      },
      {
        path: "myprofile",
        element: (

          <Profile />
        ),
      },
      {
        path: "purchaseprofile",
        element: <MyProfile />,
        children: [
          {
            index: true,
            element: (

              <PurchaseProfile />
            ),
          },
          // {
          //   path: "additional-document-required/:id",
          //   element: (
          //     <DocumentRequiredForPurchase />
          //   ),
          // },
          
          {
            path: "additional-document-required/:id",
            element: (
              <KybDocumentforPurchaseProfile />
            ),
          },
          {
            path: "identity-verification",
            element: (
              <>
                <IndentityVerificationWrapper />
              </>
            ),
            
            children: [
              {
                index: true,
                element: (
                  <KybIndentityVerification />
                ),
              },
              {
                path: "inprogress",
                element: (
                  <Inprogress />
                ),
              },
              {
                path: "business-info/:id",
                element: (
                  <PurchaseProfileBusinessInfo />
                ),
              },
              {
                path: "business-info",
                element: (
                  <PurchaseProfileBusinessInfo />
                ),
              },
              {
                path: "business/inprogress",
                element: (
                  <BusinessInprogress />
                ),
              },
            ],
          },
          {
            path: "identity-verification/:id",
            element: (
              <>
                <IndentityVerificationWrapper />
              </>
            ),
            
            children: [
              {
                index: true,
                element: (
                  <KybIndentityVerification />
                ),
              },
              {
                path: "inprogress",
                element: (
                  <Inprogress />
                ),
              },
              {
                path: "business-info",
                element: (
                  <BusinessInfo />
                ),
              },
              {
                path: "business/inprogress",
                element: (
                  <BusinessInprogress />
                ),
              },
            ],
          },
          {
            path: "account-verification",
            element: (
              <BankAccountVerification />
            ),
            children: [
              {
                path: "add-bank-account",
                element: (

                  <AddBankAccount />

                ),
              },
              {
                path: "add-funds",
                element: (
                  <AddFunds />
                ),
              },
              {
                path: "add-funds-wired-transfer",
                element: (
                  <AddFundsBank />
                ),
              },
            ],
          },
        ],
      },
      {
        path: "completedauctions",
        element: <CompletedAuction />,
      },
      {
        path: "disclosuredocuments",
        element: (
          <DisclosureDocuments />
        ),
      }
    ],
  },
  {
    path: "/signup",
    element: (
      <ProtectedRoute>
        <Signup />
      </ProtectedRoute>
    ),
  },
  {
    path: "/signin",
    element: (
      <ProtectedRoute>
        <Signin />
      </ProtectedRoute>
    ),
  },
  {
    path: "/kyc-kyb",
    element: (
      <ProtectedRoute>
        <KYB />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "identity-verification",
        element: (
          <IdentityVerification />
        ),
        children: [
          {
            index: true,
            element: (
              <Form />
            ),
          },
          {
            path: "pending",
            element: (
              <Emailvalidation />
            ),
          },
          {
            path: "failed",
            element: (
              <VerificationFailed />
            ),
          },
          {
            path: "waiting",
            element: (
              <SilaVerificationFailed />
            ),
          },
          {
            path: "inprogress",
            element: (
              <Inprogress />
            ),
          },
          {
            path: "business-info",
            element: (
              <BusinessInfo />
            ),
          },
          
          {
            path: "individual/inprogress-validate",
            element: (
              <InprogressValidation />
            ),
          },
          {
            path: "inprogress",
            element: (
              <Inprogress />
            ),
          },
          {
            path: "business/inprogress-validate",
            element: (
              <BusinessInprogress />
            ),
          },
          // {
          //   path: "individual/additional-document",
          //   element: (
          //     <DocumentVerification />
          //   ),
          // },
          {
            path: "individual/additional-document",
            element: (
              <DocumentVerificationPriority />
            ),
          },
          // {
          //   path: "business/additional-document",
          //   element: (
          //     <KybUplaodDocument />
          //   ),
          // },
          {
            path: "business/additional-document",
            element: (
              <KybdocumentVerification />
            ),
          },
          {
            path: "individual/additional-document-reupload",
            element: (
              <ReUploadDocumentVerification />
            ),
          },
        ],
      },
      {
        path: "bidding-agreement",
        element: (

          <BiddingAgreement />
        ),
        children: [
          {
            index: true,
            element: (
              <BiddingAgreementForm />
            ),
          },
        ],
      },
      {
        path: "account-verification",
        element: (
          <BankAccountVerification />
        ),
        children: [
          {
            path: "add-bank-account",
            element: (

              <AddBankAccount />

            ),
          },
          {
            path: "add-funds",
            element: (
              <AddFunds />
            ),
          },
          {
            path: "add-funds-wired-transfer",
            element: (
              <AddFundsBank />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/not-invited",
    element: (
      <NotInvitedUser />
    )
  },
  {
    path: "/PassportAccountAgreement",
    element: (
      <DocRender />
    )
  }
]);